import getCdnUrl from '@fingo/lib/helpers/get-cdn-url';

const noCredentialsIcon = getCdnUrl('/common_assets/no_credentials.avif');

export default noCredentialsIcon;